// Components
import { ProposalDAOInterface } from '../ProposalDAO';
import { ComparisonItemBasedProposalDAO } from '../ProposalDAOImpl';
import * as ProposalNS from '../../Proposal';
import * as ProposalElementNS from '../../ProposalElements';

export default class ToolbarDAO extends ComparisonItemBasedProposalDAO {
  public static buildInstance(proposal: ProposalNS.Proposal, proposalElement: ProposalElementNS.ProposalDataElement): ProposalDAOInterface {
    return new ToolbarDAO(proposal, proposalElement);
  }

  /* eslint-disable-next-line class-methods-use-this */
  protected getColorKeys(): string[] {
    return [];
  }

  /* eslint-disable-next-line class-methods-use-this */
  protected build(): void {}
}
